import "./intro.scss";
import React from "react";
import { init } from "ityped";
import { Call, Mail } from "@material-ui/icons";
import { useEffect, useRef } from "react";
import Facebook from "@material-ui/icons/Facebook";
import LinkedIn from "@material-ui/icons/LinkedIn";
import GitHub from "@material-ui/icons/GitHub";
import Twitter from "@material-ui/icons/Twitter";

export default function Intro({darkMode}) {
  
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      backDelay: 1500,
      backSpeed: 60,
      showCursor: true,
      strings: ["Backend Engineer;"],
    });
  }, []);

  return (
    <div className={`intro ${darkMode? 'light': 'dark'}`} id="intro">
      <div className="left">
        <div
          className="imageContainer"
          style={{
            backgroundImage: "url('assets/main.JPEG')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* <img src='assets/main.JPEG' alt='' /> */}
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Mohanad Safwat</h1>
          <h3>
            Software Engineer <span ref={textRef}></span>
          </h3>

          <div className="social">
            <a
              href="https://www.facebook.com/MuhanadSafwat"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook className="facebook" />
            </a>
            <a
              href="https://www.linkedin.com/in/mohanadsafwat"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedIn className="linkedin" />
            </a>
            <a
              href="https://www.github.com/MohanadSafwat"
              target="_blank"
              rel="noreferrer"
            >
              <GitHub className="github" />
            </a>
            <a
              href="https://www.twitter.com/MuhanadSafwat"
              target="_blank"
              rel="noreferrer"
            >
              <Twitter className="twitter" />
            </a>
          </div>
          <div className="contact">
            <a href="tel:+20 1022944586">
              <Call className="icon" />
              {/* <span>+20 1022944586</span> */}
            </a>
            <a href="mailto:mohanadsafwat@icloud.com">
              <Mail className="icon" />
              {/* <span>mohanadsafwat@icloud.com</span> */}
            </a>
          </div>

          <a href="#portfolio">
            <img src="assets/down.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  );
}
